export default {
  // 登录
  getToken: 'pms/auth/posWeb/login', // 获取token
  logout: 'pms/auth/admin/logout', // 退出登录
  getPhoneCode: 'pms/msgSend/getVCode', // 获得手机验证码
  verificationPhoneCode: 'pms/msgSend/verification', // 校验验证码
  modifyPwd: 'pms/auth/updatePassword', // 修改密码

  // 台位
  getoutlets: 'pms/api/v1/pos/outlets/getOrderList', //获取营业点列表
  getTableList: 'pms/api/v1/common/commomQuery/posMealTableList', //获取餐桌列表
  openTai: 'pms/api/v1/pos/order/orderRecord/order', //开台
  orderByTable: 'pms/api/v1/pos/order/orderRecord/orderByTable2', //点击餐桌，显示点菜详情列表
  updateorderRecord: 'pms/api/v1/pos/order/orderRecord/updateOrder', //修改菜单详情
  updateV: 'pms/api/v1/pos/mealTable/updateV', //餐桌脏台改空闲
  printModelType: 'pms/api/v1/pos/printStyle/modelType', //查询打印模板

  // 下拉框查询
  getDictDataList: 'pms/api/v1/dict/dictData/getDictDataList', //开台类别查询
  getsalesPersonList: '/pms/api/v1/pos/salesPerson/list', //销售查询
  getlistByParam: 'pms/api/v1/pos/technician/listByParam', //技师查询

  // 点菜
  getMealList: 'pms/api/v1/pos/foodMealDishes/getAllDishesList', //获取菜品列表
  getFoodBookList: 'pms/api/v1/common/commomQuery/posFoodBookList', //获取菜本列表
  deleteTrue: 'pms/api/v1/pos/order/orderMenu/deleteTrue', //删除菜
  getFoodTypeMap: 'pms/api/v1/pos/foodType/getFoodTypeMap', //获取菜类列表
  orderDishes: 'pms/api/v1/pos/order/orderRecord/orderDishes', //点菜
  updateQuantity: 'pms/api/v1/pos/order/orderMenu/updateQuantity', //改数量
  addMenu: 'pms/api/v1/pos/order/orderMenu/addMenu', //加菜
  punchingMenu: 'pms/api/v1/pos/order/orderMenu/punchingMenu', //冲菜/退菜
  punchingMenuAll: 'pms/api/v1/pos/order/orderMenu/punchingMenuAll', //批量冲菜，退菜
  cancell: 'pms/api/v1/pos/order/orderRecord/cancell', //消单
  onAccount: 'pms/api/v1/pos/order/orderRecord/onAccount', //挂单
  posLinkList: 'pms/api/v1/common/commomQuery/posLinkList', //联单
  orderRecordaddLink: 'pms/api/v1/pos/order/orderRecord/addLink',
  dishesCount: 'pms/api/v1/pos/order/orderRecord/dishesCount', //获取点菜 未送单数量
  deleteDishesAll: 'pms/api/v1/pos/order/orderMenu/deleteDishesAll', //全部取消
  listByOutletId: 'pms/api/v1/pos/foodWayType/listByOutletId', //点菜要求
  transferMenus: 'pms/api/v1/pos/order/orderMenu/transferMenus', //批量转菜
  discountSchemeList: 'pms/api/v1/marketing/discountScheme/poslist', //优惠理由
  menuDiscount: 'pms/api/v1/pos/order/orderMenu/menuDiscount', //单菜折扣
  recover: 'pms/api/v1/pos/order/orderRecord/recover', //追回
  splitMenu: 'pms/api/v1/pos/order/orderMenu/splitMenu', //分单
  zeroCodeByTable: 'pms/api/v1/pos/foodDishes/zeroCodeByTable', //结账零头码
  listPos: 'pms/api/v1/log/posUpdateLog/listPos', //日志

  // 菜品维护
  getappList: 'pms/api/v1/pos/foodDishes/appList', //获取菜品列表
  orderDishesList2: 'pms/api/v1/pos/order/orderRecord/orderDishesList2', //获取菜品列表
  changeDishesStatus: 'pms/api/v1/pos/foodDishes/changeDishesStatus', //设推荐菜/欢迎菜/热卖菜/锁菜
  setEstimate: 'pms/api/v1/pos/estimate/setEstimate', //沽清
  deleteEstimate: 'pms/api/v1/pos/estimate/deleteEstimate', //单个/批量删除估清
  estimateList: 'pms/api/v1/pos/estimate/estimateList', //估清列表查询
  delayedEstimate: 'pms/api/v1/pos/estimate/delayedEstimate', //单个/批量估清延期

  // 餐单查询
  menuQuery: 'pms/api/v1/pos/order/orderRecord/menuQuery', //餐单查询-左边列表
  getListMap2: 'pms/api/v1/org/employee/getListMap2', //餐单查询-工号查询
  getTableNumList: 'pms/api/v1/pos/mealTable/getTableNumList', //餐单查询-餐桌号查询
  menuQueryTotal: 'pms/api/v1/pos/order/orderRecord/menuQueryTotal', //餐单查询-左边列表-统计
  menuQueryInfoTo2: 'pms/api/v1/pos/order/orderRecord/menuQueryInfoTo2', //餐单查询-右边菜品详情（新）

  billList: 'pms/api/v1/pos/orderBill/billList', //结账明细列表
  revokePosBill: 'pms/api/v1/pos/order/orderMenu/revokePosBill', //撤销结账
  reCalcOrder: 'pms/api/v1/pos/order/orderRecord/refreshOrder', //刷新

  // 预订
  bookList: 'pms/api/v1/pos/order/orderRecord/bookList', //预订列表查询
  getByPosCode: 'pms/api/v1/pos/mealDiffer/getByPosCode', //根据设备编码查询餐别（免会话）
  getByList: 'pms/api/v1/pos/mealDiffer/list', //根据设备编码查询餐别（免会话）
  bookGrid: 'pms/api/v1/pos/order/orderRecord/bookGrid', //预订分布网格图数据查询
  addbook: 'pms/api/v1/pos/order/orderRecord/book', //新增预订
  editBookOrder: 'pms/api/v1/pos/order/orderRecord/editBookOrder', //预订单修改
  discountModel: 'pms/api/v1/pos/discountModel/freeDiscount', //打折模式->所有数据查询
  updateDiscount: 'pms/api/v1/pos/order/orderRecord/updateDiscount', //打折模式->保存接口
  getByOutletsIds: 'pms/api/v1/pos/mealTable/getByOutletsIds', //查询多个营业点下餐桌信息
  posGetCustList: 'pms/api/v1/guest/customer/posGetCustList', //查询客户/单位列表
  GetwaiterList: 'pms/api/v1/pos/waiter/list', //服务员->所有服务员查询
  GetsalesPersonList: 'pms/api/v1/pos/salesPerson/list', //销售员->所有数据查询
  bookCancel: 'pms/api/v1/pos/order/orderRecord/bookCancel', //预订取消
  bookRecovery: 'pms/api/v1/pos/order/orderRecord/bookRecovery', //预订恢复
  bookRegister: 'pms/api/v1/pos/order/orderRecord/bookRegister', //预订登记

  // 报表
  getListMap: 'pms/api/v1/org/employee/getListMap', //工号查询列表
  orderTotal: 'pms/api/v1/pos/order/orderReport/orderTotal', //餐单消费明细表
  bookByOutlets: 'pms/api/v1/pos/foodBook/bookByOutlets',
  foodTypeByBooks: 'pms/api/v1/pos/foodType/foodTypeByBooks',
  handoverSalesReport: 'pms/api/v1/pos/order/orderReport/handoverSalesReport2', //营业点交班表-销售
  statisticsReport2: 'pms/api/v1/pos/order/orderReport/statisticsReport2', //营业点交班表-统计
  collectionReport: 'pms/api/v1/pos/order/orderReport/collectionReport2', //营业点交班表-收款
  posDishesSaleRanking: 'pms/api/v1/common/commomQuery/posDishesSaleRanking', //菜品销售榜
  payTypeTotal: 'pms/api/v1/pos/order/orderReport/payTypeTotal2', //营业点交班表-纵向
  getuserinfo: '/pms/auth/getPosLoginInfo',
  posDishesSaleRanking: '/pms/api/v1/common/commomQuery/posDishesSaleRanking',
  posSalesDetailsList: '/pms/api/v1/common/commomQuery/posSalesDetailsList',
  posPunchingMenuList: '/pms/api/v1/common/commomQuery/posPunchingMenuList',
  operatingIncome: '/pms/api/v1/pos/order/orderReport/operatingIncome',
  posDayliReport: '/pms/api/v1/pos/order/orderReport/posDayliReport',
  // 结账
  posProductPayList: 'pms/api/v1/common/commomQuery/posProductPayList', //支付方式列表
  posBill: 'pms/api/v1/pos/order/orderMenu/posBill', //结账
  queryARAccount: 'pms/api/v1/common/commomQuery/queryARAccount', //AR账列表
  parmsList: 'pms/api/v1/guest/memberInfo/parmsList', //会员账列表
  queryAccount: 'pms/api/v1/common/commomQuery/queryAccount', //房间账列表
  sweepPay: 'pms/api/v1/pay/wechatPay/sweepPay', //微信扫码支付

  //退款
  bykey: 'pms/api/v1/sys/systemConfig/byKey', //获取财务电话
  refund: 'pms/api/v1/pos/order/orderMenu/refund', //退款
  printBillInfo: 'pms/api/v1/pos/order/orderRecord/printBillInfo', //退款

  correcting: 'pms/api/v1/pos/mealTable/correcting', //刷新餐桌状态
  listByParam: 'pms/api/v1/pos/salesPerson/listByParam', //销售员列表
  waiterlistByParam: 'pms/api/v1/pos/waiter/listByParam', //销售员列表
  updateName: 'pms/api/v1/pos/order/orderMenu/updateName', //改菜名
  updatePrice: 'pms/api/v1/pos/order/orderMenu/updatePrice', //改数量
  changTable: 'pms/api/v1/pos/order/orderRecord/changTable', //换台
  posGetList: 'pms/api/v1/guest/memberInfo/posGetList', //会员列表

  // orderMq: 'pms/api/v1/mq/orderMq/map2', //调用ipad打印
  orderMq: 'pms/api/v1/mq/orderMq/map2Queue', //调用ipad打印
  printPosCode: 'pms/api/v1/pos/controlOutlets/printPosCode', //调用ipad打印
  mainPrinterPosCode: 'pms/api/v1/pos/controlOutlets/mainPrinterPosCode', //调用ipad打印
  getCurPosSite: 'pms/api/v1/pos/posSite/getCurPosSite', //当前登录POS设备信息查询
  getByDocuments: 'pms/api/v1/manager/printClassify/getByDocuments', //账单模板
  hotelTemplate: 'pms/api/v1/manager/printTemplate/hotelTemplate', //账单模板

  bookBill: 'pms/api/v1/pos/orderBill/bookBill', //预付款列表
  orderMenuBill: 'pms/api/v1/pos/order/orderMenu/bookBill', //预付款列表
  bookBillList: 'pms/api/v1/pos/orderBill/bookBillList', //预付款列表
  bookListWeb: 'pms/api/v1/pos/order/orderRecord/bookListWeb', //预订单列表
  bookRefund: 'pms/api/v1/pos/orderBill/bookRefund', //预付款退款
  posBookMealTableList: 'pms/api/v1/common/commomQuery/posBookMealTableList', //预付款退款
  printBookBillInfo: 'pms/api/v1/pos/order/orderRecord/printBookBillInfo', //预付款打印
  bookUpdateDiscount: 'pms/api/v1/pos/order/orderRecord/bookUpdateDiscount', //修改折扣模式

  statistics: 'pms/api/v1/pos/breakfastWriteOff/statisticsNew', //核销首页统计导航
  getWriteOffInfo: 'pms/api/v1/pos/breakfastWriteOff/getWriteOffInfo', //核销首页统计导航
  lockCode: 'pms/api/v1/manager/lock/lockCode', //查询门锁接口类型
  readCard: 'http://127.0.0.1:7999/lock/readCard', //查询门锁接口类型
  readCards: 'pms/api/v1/room/roomCard/readCard', //查询门锁接口类型
  writeOff: 'pms/api/v1/pos/breakfastWriteOff/writeOffNew', //查询门锁接口类型
  writeOffList: 'pms/api/v1/pos/breakfastWriteOff/getListNew', //查询门锁接口类型
  writeCancel: 'pms/api/v1/pos/breakfastWriteOff/cancelWriteOff',
  statisticsReport: 'pms/api/v1/pos/breakfastWriteOff/statisticsReport',
  isBreakfast: 'pms/api/v1/pos/posSite/isBreakfast',
  getWriteInfo: 'pms/api/v1/pos/breakfastWriteOff/getWriteInfo', //核销信息

  accountRepair: 'pms/api/v1/pos/order/orderRecord/repairAccount', //修复金额
  kcReportList: 'pms/api/v1/pos/order/orderReport/kcReportList',
  getMealCategory: 'pms/api/v1/goods/setMeal/selectList',
  kcCorpWriteOffTotal: 'pms/api/v1/pos/order/orderReport/kcCorpWriteOffTotal', //单位核销统计汇总
  kcCorpWriteOffInfo: 'pms/api/v1/pos/order/orderReport/kcCorpWriteOffInfo', //单位核销统计明细
  timeWriteOffInfo: 'pms/api/v1/pos/order/orderReport/kcCorpWriteOffTotal2',
  kcCustWriteOffTotal: 'pms/api/v1/pos/order/orderReport/kcCustWriteOffTotal',
};
